import { render, staticRenderFns } from "./chapter-list.vue?vue&type=template&id=5f5d9ac2&scoped=true"
import script from "./chapter-list.vue?vue&type=script&lang=js"
export * from "./chapter-list.vue?vue&type=script&lang=js"
import style0 from "./chapter-list.vue?vue&type=style&index=0&id=5f5d9ac2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f5d9ac2",
  null
  
)

export default component.exports